import { Image, withContent } from '@bubbletea/core';
import { IContent } from '../../../types';

import { LegalContainer } from './styles';

interface ILatestUpdatesProps {
  context: IContent;
}

const Legal = ({ context }: ILatestUpdatesProps) => {
  const { legal } = context.googlesheet;
  const { description, image, alt } = legal;

  return description || image ? (
    <LegalContainer>
      {image ? <Image imageNames={[image as string]} altText={alt as string} /> : null}
      {description ? <p>{description}</p> : null}
    </LegalContainer>
  ) : null;
};

export default withContent(Legal);
